<script>
import Base from '@/plans/ROOM_CONNECTOR/config/base';

export default {
  extends: Base,
  data() {
    return {
      showCycleAlert: false
    };
  },
  computed: {
    canRmv() {
      return this.isShowRemoveBtn;
    },
  },
};
</script>
